"use client"
import clsx from "clsx"
import React from "react"
import "./styles.css"
import SummaryHeader from "./Summary/SummaryHeader"
import SummarySetting from "./Summary/SummarySetting"
interface PriceCalculatorProps {
	locale: string
	setting?: any
}

const PriceCalculatorOne: React.FC<PriceCalculatorProps> = ({ locale, setting = {} }) => {

	const packages = setting?.packages || []
	const providers = setting?.providers || []

	const [planActivated, setPlanActivated] = React.useState<any>(() => packages.find((i: any) => i.id === 1))
	const [locationSelected, setLocationSelected] = React.useState<Array<any>>(() => {
		return providers?.find((provider: any) => provider.region === "global")?.items?.filter((item: any) => ["global-vncdn"].includes(item.id)) || []
	})

	const [isPlanSelectionActive, setIsPlanSelectionActive] = React.useState<boolean>(false)
	const [isPlanAdvancedSettingActive, setIsPlanAdvancedSettingActive] = React.useState<boolean>(false)
	const [trafficUsage, setTrafficUsage] = React.useState<number>(0)
	const [dnsRecordUsage, setDnsRecordUsage] = React.useState<number>(0)
	const [dnsQueryUsage, setDnsQueryUsage] = React.useState<number>(0)
	const [cacheRuleUsage, setCacheRuleUsage] = React.useState<number>(0)

	const pricingCalculator = () => {
		const packagePrice = Number(planActivated?.price)

		let [
			priceIntegrationTotal,
			integrationUsageTotal,
			priceIntegrationFreeLimit,
			priceTrafficTotal,
			priceRequestTotal
		] = [0, locationSelected.length, planActivated?.defaultIntegrationFreeLimit, 0, 0]

		if (planActivated?.id === 3) return planActivated?.price

		const integrationUnitPrice = (integrationUsageTotal > 100) ? setting.mcdn?.large : (integrationUsageTotal > 50) ? setting.mcdn?.medium : setting.mcdn?.small

		// perform sum all of cdn price * trafficUsage and then get average
		Array.from(locationSelected).forEach((location: any) => {
			const trafficLimitLowerThan = location.prices?.traffic?.find((item: any) => item.eq === "-lt" ? trafficUsage <= item.limit : trafficUsage > item.limit)

			// console.log(trafficLimitLowerThan)

			if (trafficLimitLowerThan) {
				priceTrafficTotal += ((trafficLimitLowerThan?.price || 0) * trafficUsage)
			}
		})

		if (integrationUsageTotal > priceIntegrationFreeLimit) {
			// integrationUsageTotal = integrationUsageTotal - priceIntegrationFreeLimit
			integrationUsageTotal = integrationUsageTotal
		} else {
			integrationUsageTotal = 0
		}

		priceIntegrationTotal = Math.round(integrationUsageTotal * integrationUnitPrice)
		priceTrafficTotal = Math.round((priceTrafficTotal / locationSelected.length))

		return `${setting?.currency?.mark || "$"}${packagePrice + priceIntegrationTotal + (isNaN(priceTrafficTotal) ? 0 : priceTrafficTotal)}`
	}

	const handleLocationSelected = (location: any) => {
		let items = [...locationSelected]

		if (items.find((item: any) => item.id === location.id)) {
			items = items.filter((item: any) => item.id !== location.id)
		} else {
			items = items.concat([location])
		}

		setLocationSelected(items)
	}

	React.useEffect(() => {
		if (planActivated) {
			setTrafficUsage(planActivated?.defaultTraffic || 0)
			setDnsRecordUsage(planActivated?.dns?.defaultRecord || 0)
			setDnsQueryUsage(planActivated?.dns?.defaultQuery || 0)
			setCacheRuleUsage(planActivated?.edge?.defaultCacheRule || 0)
		}
	}, [planActivated])

	return (
		<>
			<div className="price-calculator-one mt-5 d-flex h-100" data-ui="module.ui:PriceCalculatorOne">
				<div className="w-100 my-auto">
					<div className="row">
						<div className="col-md-3 col-12">
							<div className="text-start">
								<div className="mb-3">
									<p className="fw-bold">Plan</p>
									<div className={clsx("plan-select rounded border p-3 cursor-pointer d-flex justify-content-between", isPlanSelectionActive && "active")} onClick={() => setIsPlanSelectionActive(!isPlanSelectionActive)}>
										<p className="mb-0 fw-bold text-primary">{planActivated?.name}</p>
										<span className="arrow" />
									</div>
									{isPlanSelectionActive && <div className="plan-select-options rounded shadow">
										{packages.map((item: any, index: number) => {
											return (
												<p className={clsx("mb-0 plan-select-options--item cursor-pointer p-3", planActivated.id === item.id && "selected")} onClick={() => [setPlanActivated(() => packages.find((i: any) => i.id === item.id)), setIsPlanSelectionActive(false)]} key={index}>{item.name}</p>
											)
										})}
									</div>}
								</div>
								<div className="plan-select--custom-traffic mb-3">
									<p className="fw-bold">Estimated traffic / mo</p>
									<div className="d-flex">
										<input className="plan-select--custom-traffic--input mb-auto" defaultValue={trafficUsage} value={trafficUsage} onChange={(event: any) => !isNaN(Number(event.target?.value)) && setTrafficUsage(Number(event.target?.value))} />
										<p className="mb-auto">GB</p>
									</div>
								</div>
								<div className="plan-select--custom-traffic mb-4">
									<p className="fw-bold"># of domains</p>
									<div className="d-flex">
										<input className="plan-select--custom-domain--input mb-auto" defaultValue={1} />
									</div>
								</div>
								<div className={clsx("plan-advanced--heading d-flex cursor-pointer", isPlanAdvancedSettingActive && "active")} onClick={() => setIsPlanAdvancedSettingActive(!isPlanAdvancedSettingActive)}>
									<p className="fw-bold">Advanced settings</p>
									<span className="arrow" />
								</div>
								{isPlanAdvancedSettingActive && (
									<>
										<div className="plan-select--custom-traffic mb-4">
											<p className="fw-bold"># of DNS records</p>
											<div className="d-flex">
												<input className="plan-select--custom-dns-records--input mb-auto" defaultValue={dnsRecordUsage} value={dnsRecordUsage} />
											</div>
										</div>
										<div className="plan-select--custom-traffic mb-4">
											<p className="fw-bold"># of DNS queries</p>
											<div className="d-flex">
												<input className="plan-select--custom-dns-queries--input mb-auto" defaultValue={dnsQueryUsage} value={dnsQueryUsage} />
												<p className="mb-auto">milion</p>
											</div>
										</div>
										<div className="plan-select--custom-traffic mb-4">
											<p className="fw-bold"># of Cache rules</p>
											<div className="d-flex">
												<input className="plan-select--custom-dns-rules--input mb-auto" defaultValue={cacheRuleUsage} value={cacheRuleUsage} />
											</div>
										</div>
									</>
								)}
							</div>
						</div>
						<div className="col-md-6 col-12">
							<div className="text-start">
								<p className="fw-bold">Your PoP coverage</p>
							</div>
							<div className="mb-3">
								<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 1300 600">
									<g style={{ isolation: "isolate" }}>
										<image href="/map.svg" width="100%" height="600" />
										{locationSelected.map((item: any, index: number) => {
											return item.locations.map((location: any, index: number) => {
												return (
													<g
														opacity={1}
														className="cursor-default"
														key={index}
													>
														<rect
															width={10}
															height={10}
															fill="var(--bs-primary)"
															x={location.x}
															y={location.y}
															rx={1}
															opacity={0.5}
															strokeWidth={1}
														/>
													</g>
												)
											})
										})}
									</g>
								</svg>
							</div>
							<div>
								{providers.map((group: any, index: number) => {
									return (
										<div className={clsx(`col-md-${group.region === "global" ? 6 : 3}`, "col-12")} key={index}>
											<div className="border rounded">
												<div style={{ marginTop: "-1.25rem" }}>
													<div className="bg-white d-inline-block p-2 small fw-bold">{group.name}</div>
												</div>
												<div className="mcdn-select p-3">
													<div className="row">
														{group.items.map((item: any, index: number) => {
															return (
																<div className={clsx(`col-md-${group.region === "global" ? 6 : 12}`, "col-12 px-1 my-1")} key={index}>
																	<div className={clsx("mcdn-select--item border bg-light cursor-pointer", locationSelected.find((location: any) => location.id === item.id) && "selected")} onClick={() => handleLocationSelected(item)} style={{ borderRadius: 50, padding: 4 }}>
																		<p className="mb-0" style={{ fontSize: 12 }}>{item.name}</p>
																	</div>
																</div>
															)
														})}
													</div>
												</div>
											</div>
										</div>
									)
								})}
							</div>
						</div>
						<div className="col-md-3 col-12">
							<SummaryHeader />
							<div className="mb-3 w-100 shadow rounded text-start">
								<div className="p-3 bg-primary-dark rounded-top">
									<h5 className="mb-0 text-white">{planActivated?.name}</h5>
								</div>
								<div className="pb-3 p-3">
									<p className="fw-bold">{setting?.currency?.code || "USD"}</p>
									<div className="d-flex justify-content-end">
										<h2>{pricingCalculator()}</h2>
										<span className="fw-bold text-muted my-auto"> / month</span>
									</div>
								</div>
							</div>
							<SummarySetting setting={setting} locale={locale} />
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default PriceCalculatorOne